import { ReactNode } from "react";
import { ErrorBoundaryProps, withErrorBoundary } from "react-error-boundary";
import { YMInitializer } from "react-yandex-metrika";
import { FullPageError } from "@pages/error";
import { tracerError, TracerIssueKey } from "@shared/lib/tracer";
import { AntdGlobalProvider } from "./with-antd";
import { CaslProvider } from "./with-casl";
import { LegacyIframeProvider } from "./with-legacy-iframe";
import { withPdfViewer } from "./with-pdf-viewer";
import { QueryClientProvider } from "./with-query-client";
import { BrowserRouter } from "./with-router";
import { withSuspense } from "./with-suspense";
import "../styles/index.css";

const YM_ACCOUNT =
  import.meta.env.VITE_NODE_ENV === "development" ? 103522924 : 103509264;

function Providers() {
  return (
    <>
      <YMInitializer
        accounts={[YM_ACCOUNT]}
        options={{ webvisor: true }}
        version="2"
      />
      <AntdGlobalProvider>
        <QueryClientProvider>
          {withPdfViewer(
            <CaslProvider>
              <LegacyIframeProvider>
                <BrowserRouter />
              </LegacyIframeProvider>
            </CaslProvider>,
          )}
        </QueryClientProvider>
      </AntdGlobalProvider>
    </>
  );
}

const SuspenseProvider = withSuspense(Providers, {
  fallback: (<div>загрузка</div>) as ReactNode,
});
export const Provider = withErrorBoundary(SuspenseProvider, {
  fallbackRender: ({ error }) => (
    <FullPageError error={error} issueKey={TracerIssueKey.BoundaryRoot} />
  ),
  onError: (error) => {
    tracerError.error(error, {
      severity: "fatal",
      issueKey: TracerIssueKey.BoundaryRoot,
      component: "RootErrorBoundary",
    });
  },
} as ErrorBoundaryProps);
